export { default } from './InstagramFeed'
